/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TValidateAddressWebModel,
  IValidateAddressWebRequest,
  IMappers,
  IValidateAddressWebResponse,
  IValidateAddressWebResponseError,
  TValidateAddressWebResponse,
} from './types';

const defaultConfig: TValidateAddressWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'geo-suggest',
  pathApi: '/v2/validate-address-web/',
  hostType: 'api',
} as TValidateAddressWebModel;

function createValidateAddressWebModel(parameters: IValidateAddressWebRequest): TValidateAddressWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IValidateAddressWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IValidateAddressWebRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchValidateAddressWeb<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IValidateAddressWebOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TValidateAddressWebResponse
> {
  const { response, statusCode } = await httpApi.fetch(createValidateAddressWebModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IValidateAddressWebResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IValidateAddressWebResponseError);
    }
  }

  return { response, statusCode } as TValidateAddressWebResponse;
}

export { defaultConfig, createValidateAddressWebModel, fetchValidateAddressWeb };
